import React, { useEffect, useState } from "react";
import { Mail, Phone } from "lucide-react";
import api from "../../lib/api";
import { PageTitle, Card, Loading } from "./ui";

export default function Directory() {
  const [members, setMembers] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/portal/directory").then((r) => setMembers(r.data)).catch(() => setMembers([]));
  }, []);

  if (!members) return <Loading />;
  const shown = members.filter(
    (m) => m.name.toLowerCase().includes(q.toLowerCase()) || (m.rank || "").toLowerCase().includes(q.toLowerCase())
  );

  const initials = (name) =>
    name.replace(/^(W\.?\s?Bro\.?|Bro\.?)\s*/i, "").split(" ").map((n) => n[0]).slice(0, 2).join("");

  return (
    <div data-testid="directory-page">
      <PageTitle eyebrow="Brethren" title="Member Directory" sub="Members choose which details are shown. Contact fields are opt-in." />

      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search by name or rank…"
        className="mb-6 w-full max-w-sm rounded-xl border border-sapphire-deep/15 bg-sapphire-deep/[0.04] px-4 py-3 font-sans text-sapphire-deep outline-none focus:border-gold"
        data-testid="directory-search"
      />

      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {shown.map((m) => (
          <Card key={m.id}>
            <div className="flex items-center gap-4">
              <div className="flex h-14 w-14 items-center justify-center rounded-full bg-gold/15 font-display text-xl font-semibold text-gold-deep">
                {initials(m.name)}
              </div>
              <div>
                <h3 className="font-display text-lg font-semibold text-sapphire-deep">{m.name}</h3>
                <p className="font-sans text-xs uppercase tracking-widest text-gold-deep">{m.rank}</p>
              </div>
            </div>
            <div className="mt-4 space-y-2 border-t border-sapphire-deep/10 pt-4 font-sans text-sm text-ink/65">
              <p>Initiated {m.year_initiated}</p>
              {m.phone && <p className="flex items-center gap-2"><Phone size={14} className="text-gold-deep" /> {m.phone}</p>}
              <p className="flex items-center gap-2"><Mail size={14} className="text-gold-deep" /> {m.email}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
